import { Cartridge, CartridgeApi, CartridgeStatus, Widget } from '@markant-platform/cartridge/model';

export const MOCK_WIDGETS_ARRAY: Widget[] = [
  {
    id: '58ff2e7f-9a83-4a4c-8179-01203b379222',
    displayName: 'Zähler-Widget',
    componentName: 'CounterWidgetComponent',
    exposedModule: './CounterWidget',
    focusView: {
      routePath: 'cartridge-prototyp/zaehler',
      exposedModule: './CounterFocus',
      ngModuleName: 'CounterWidgetFocusViewModule',
    },
    size: '1x1',
  },
  {
    id: 'a7bc4afb-164f-476d-9a46-522018ab7b13',
    displayName: 'Diagramm-Widget',
    componentName: 'DiagramWidgetComponent',
    exposedModule: './DiagramWidget',
    focusView: {
      routePath: 'cartridge-prototype/diagramm',
      exposedModule: './DiagramFocus',
      ngModuleName: 'DiagramWidgetFocusViewModule',
    },
    size: '1x2',
  },
  {
    id: '587b8124-cfd3-4c32-b995-c2694b07a72a',
    displayName: 'Interaktion-Widget',
    componentName: 'InteractionWidgetComponent',
    exposedModule: './InteractionWidget',
    focusView: {
      routePath: 'cartridge-prototype/interaktion',
      exposedModule: './InteractionFocus',
      ngModuleName: 'InteractionWidgetFocusViewModule',
    },
    size: '2x2',
  },
  {
    id: '2bc352be-3d37-450c-9b53-c61bde2d678b',
    displayName: 'Super Widget',
    componentName: 'InteractionWidgetComponent',
    exposedModule: './InteractionWidget',
    focusView: {
      routePath: 'cartridge-prototype/interaktion',
      exposedModule: './InteractionFocus',
      ngModuleName: 'InteractionWidgetFocusViewModule',
    },
    size: '1x1',
  },
  {
    id: '8b3d08ca-9e1a-411d-83b8-8a27a9a906c9',
    displayName: 'New Widget',
    componentName: 'CounterWidgetComponent',
    exposedModule: './CounterWidget',
    focusView: {
      routePath: 'cartridge-prototype/zaehler',
      exposedModule: './CounterFocus',
      ngModuleName: 'CounterWidgetFocusViewModule',
    },
    size: '1x1',
  },
];

export const MOCK_VISIBLE_WIDGETS: Widget[] = [MOCK_WIDGETS_ARRAY[1], MOCK_WIDGETS_ARRAY[2]];

export const MOCK_API_ARRAY: CartridgeApi[] = [
  {
    apiStatus: '',
    id: 'mock-api-id',
    pathPrefix: 'counter',
    serviceUrl: 'https://leistung-prototype.dev-platform-spoke.markant.services/',
    spec: '{"openapi":"3.0.3","info":{"title":"leistung-prototyp API","version":"1.0.0-SNAPSHOT"},"paths":{"/api/counter":{"get":{"tags":["Counter Service Resource"],"summary":"Fetch counter value","responses":{"200":{"description":"OK","content":{"application/json":{"schema":{"$ref":"#/components/schemas/Count"}}}},"401":{"description":"Not Authorized"},"403":{"description":"Not Allowed"}},"security":[{"SecurityScheme":[]}]}}}}',
  },
];

export const MOCK_CARTRIDGE_ARRAY: Cartridge[] = [
  {
    id: 'mock-variant-id-1',
    name: 'Test-Cartridge-Variant-A',
    longName: '',
    description: 'Description of the variant A',
    longDescription:
      'Long description of the variant A. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gub',
    remoteEntry: '',
    variants: [],
    status: CartridgeStatus.ACTIVE,
    widgets: [MOCK_WIDGETS_ARRAY[0], MOCK_WIDGETS_ARRAY[1], MOCK_WIDGETS_ARRAY[2]],
    legalNoticeLinks: [],
    cartridgeGroupKey: 'PROTOTYPE',
    marketingInformation: [],
    cartridgeFeatures: [],
    serviceUpgradeState: null,
  },
  {
    id: 'mock-variant-id-2',
    name: 'Test-Cartridge-Variant-B',
    longName: '',
    description: 'Description of the variant B',
    longDescription:
      'Long description of the variant B. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.',
    remoteEntry: '',
    variants: [],
    status: CartridgeStatus.ACTIVE,
    widgets: [MOCK_WIDGETS_ARRAY[3], MOCK_WIDGETS_ARRAY[4]],
    legalNoticeLinks: [],
    cartridgeGroupKey: 'PROTOTYPE',
    marketingInformation: [],
    cartridgeFeatures: [],
    serviceUpgradeState: null,
  },
];
